import React from "react";
import { useTranslation } from "react-i18next";

const TicketList = ({ ticketsData }) => {
  const { t } = useTranslation();

  // Check if there are no tickets, and display a message
  if (!ticketsData || ticketsData.length === 0) {
    return (
      <div className="flex items-center justify-center h-48">
        <p className="text-white text-lg">
          {t("ticketDetails.noTicketsFound")}
        </p>
      </div>
    );
  }

  return (
    <div className="divide-y divide-white/10">
       {ticketsData
    .slice() // Create a copy to avoid mutating the original array
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort by date (latest first)
    .map((ticket, index) => {
      // Convert created_at date string to Date object
      const date = new Date(ticket.created_at);

      // Format the date in "DD/MM/YYYY" format
      const formattedDate = date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });

        return (
          <div
            key={index}
            className="flex items-center gap-2 py-3 justify-between"
          >
            {/* Circular Emoji Container */}
            <div className="flex justify-center items-center w-12 h-12 bg-white/10 rounded-full">
              <span className="text-white text-xl">{"😊"}</span>
            </div>

            {/* Vertical Divider */}
            <div className="w-px h-auto bg-white/10"></div>

            {/* Ticket Information (Number & Date) */}
            <div className="flex-grow">
              <p className="text-white text-md">
                {t("ticketDetails.ticketNumber")} {ticket.lottery_ticket_number}
              </p>
              <p className="text-white/50 text-md">
                {t("ticketDetails.ticketDate")} {formattedDate}
              </p>
            </div>

            {/* Description */}
            <div className="mr-2">
              <p className="text-right text-white text-2xl font-serif">
                {ticket.lottery_ticket_number}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TicketList;
